import { getUser } from './auth';

const BASE = {
  type: 'public_schedule_type',
  group: 'public_schedule_group',
  teacher: 'public_schedule_teacher',
  horizon: 'public_schedule_horizon',
};

export function scheduleAccountId() {
  try {
    const user = getUser();
    if (user?.id != null && user.id !== '') return String(user.id);
    if (user?.username) return String(user.username);
  } catch (err) {
    /* ignore */
  }
  const login = localStorage.getItem('kkt_username');
  return login ? String(login) : '';
}

function scopedKey(name, accountId) {
  const id = accountId === undefined ? scheduleAccountId() : accountId;
  return id ? `${BASE[name]}:${id}` : BASE[name];
}

function readKey(name, accountId) {
  try {
    return localStorage.getItem(scopedKey(name, accountId)) || '';
  } catch (err) {
    return '';
  }
}

function writeKey(name, value, accountId) {
  const key = scopedKey(name, accountId);
  try {
    if (value) localStorage.setItem(key, value);
    else localStorage.removeItem(key);
  } catch (err) {
    /* ignore */
  }
}

function dropLegacyKeys() {
  Object.values(BASE).forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      /* ignore */
    }
  });
}

export function readSchedulePrefs() {
  const accountId = scheduleAccountId();
  return {
    type: readKey('type', accountId),
    group: readKey('group', accountId),
    teacher: readKey('teacher', accountId),
    horizon: readKey('horizon', accountId) === 'semester' ? 'semester' : 'week',
  };
}

export function writeSchedulePrefs(next = {}) {
  const accountId = scheduleAccountId();
  if (accountId) dropLegacyKeys();
  if (next.type !== undefined) writeKey('type', next.type, accountId);
  if (next.group !== undefined) writeKey('group', next.group, accountId);
  if (next.teacher !== undefined) writeKey('teacher', next.teacher, accountId);
  if (next.horizon !== undefined) writeKey('horizon', next.horizon, accountId);
}

export function clearSchedulePrefs() {
  const accountId = scheduleAccountId();
  ['type', 'group', 'teacher', 'horizon'].forEach((name) => {
    writeKey(name, '', accountId);
  });
  dropLegacyKeys();
}
